import {memo} from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import {selectOptions} from '~/ViewInvitation/selectors/eviteEvent';
import {selectGiftingData} from '~/ViewInvitation/selectors/gifting';
import {getVendorNameFromRegistry} from '~/ViewInvitation/utils/registry';
import {Typography} from '~library/atoms/Typography';
import {ClickOutLineIcon} from '~library/svg/ClickOutLineIcon';

import * as styles from './AmazonBanner.module.scss';

export const AmazonBanner = memo(() => {
  const giftIdeasEnabled = useSelector(selectOptions)?.event_option_show_gifting;
  const registry = useSelector(selectGiftingData, shallowEqual);
  const vendorName = getVendorNameFromRegistry(registry);
  // @ts-ignore icon_url is valid I guess?
  const iconUrl = registry.iconUrl || registry.icon_url;

  if (!giftIdeasEnabled) return null;

  return (
    <a
      href={registry?.url}
      target="_blank"
      data-qa-id="af-glist-disc-amazon"
      data-impression-tracking="true"
      data-qa-locator="vendor-disc"
      data-qa-value={vendorName}
      rel="noreferrer"
      className={styles.amazonBanner}
    >
      <Typography variant="paragraph2" as="span" color="charcoal">
        Buy your gift now on
      </Typography>
      <img src={iconUrl} alt={vendorName} width={81} />
      <span className={styles.linkIcon}>
        <ClickOutLineIcon ratio={0.375} />
      </span>
    </a>
  );
});

AmazonBanner.displayName = 'AmazonBanner';
